import request from './api'

export class AdminService {
    async getUsersList() {
        const response = await request({
            method: 'GET',
            url: `api/admin/users/list`
        });

        return response;
    }

    async getUserDetails(userId: string) {
        const response = await request({
            method: 'GET',
            url: `api/admin/users/${userId}/details`
        });

        return response;
    }

    async createUser(email: string, firstname: string, lastname: string, password: string, passwordConfirm: string, roleId: string) {
        const response = await request({
            method: 'POST',
            url: `api/admin/users/create`,
            data: {
                email,
                firstname,
                lastname,
                password,
                passwordConfirm,
                roleId
            }
        });

        return response;
    }

    async changePassword(userId: string, newPassword: string, newPasswordConfirm: string) {
        const response = await request({
            method: 'POST',
            url: `api/admin/users/${userId}/changepassword`,
            data: { newPassword, newPasswordConfirm }
        });

        return response;
    }

    async activate(userId: string) {
        const response = await request({
            method: 'POST',
            url: `api/admin/users/${userId}/activate`,
            data: {}
        });

        return response;
    }

    async deactivate(userId: string) {
        const response = await request({
            method: 'POST',
            url: `api/admin/users/${userId}/deactivate`,
            data: {}
        });

        return response;
    }

    async getRoles(userId: string) {
        const response = await request({
            method: 'GET',
            url: `api/admin/roles/list`
        });

        return response;
    }

    

    static get instance() { return adminService }
}

const adminService = new AdminService();

export default adminService;